export const SaleOrderDetailModel = {
    item_id: 0,
    item: { name: '' },
    item_name: '',
    item_brand_id: 0,
    item_brand: { name: '' },
    customer_type_id:0,
    customer_type:{ name: '' },
    item_unit_id: 0,
    item_unit: { name: '' },
    quantity: 0,
    unit_price: 0,
    total_price: 0,
    discount_amount: 0,
    sub_total: 0,
    unit_cost: null,
    item_cost_type: null,
    cost_required: null,
    sale_order_cost_type: 'FULL_COST',
    conversion_costs: [],
    total_cost: 0,
    tax_head_id: 0,
    tax_head: { name: '' },
    rate: 0,
    tax_amount: 0,
    net_total: 0,
    brands: []
}
